export const txtPlaceTitle = {
  id: "Akad & Resepsi",
  en: "Ceremony & Reception",
};

export const txtCeremonyPlaceholder = {
  id: "Akad Nikah",
  en: "Ceremony",
};

export const txtReceptionPlaceholder = {
  id: "Resepsi",
  en: "Reception",
};

export const txtLocationPlaceholder = {
  id: "Lokasi",
  en: "Location",
};

export const txtLocationButton = {
  id: "Lihat lokasi",
  en: "View location",
};

export const txtDateInfo = {
  id: "Sabtu, 26 Agustus 2023",
  en: "Saturday, 26 August 2023",
};

export const txtCeremonyTimeInfo = {
  id: "16.30 WIB",
  en: "16.30 WIB",
};

export const txtReceptionTimeInfo = {
  id: "19.00 WIB",
  en: "19.00 WIB",
};
